import React, { useState } from "react";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import CalculatorInput from "../CalculatorInput/CalculatorInput";
import MaleOrFemale from "../MaleOrFemale/MaleOrFemale";
import CalculatorResult from "../CalculatorResult/CalculatorResult";
import Alert from "../../../Components/Alert/Alert";
import bmiData from "./bmiData";

export default function BMI() {
  const [heightVal, setHeightVal] = useState(0);
  const [weightVal, setWeightVal] = useState(0);
  const [showHeightTooltip, setShowHeightTooltip] = useState(false);
  const [showWeightTooltip, setShowWeightTooltip] = useState(false);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [sex, setSex] = useState("female");
  const [result, setResult] = useState(0);
  const [showAlert, setShowAlert] = useState(false);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const handleInputChange = (val, inputName) => {
    if (inputName === "height") {
      setHeightVal(val);
      setShowHeightTooltip(true);
    } else {
      setWeightVal(val);
      setShowWeightTooltip(true);
    }
  };

  const handleTouchEnd = (inputName) => {
    if (inputName === "height") {
      setShowHeightTooltip(false);
    } else {
      setShowWeightTooltip(false);
    }
  };

  const changeGender = (gender) => {
    setSex(gender);
  };

  const handleComputing = () => {
    if (heightVal / 100 !== 0) {
      let BMI = (weightVal / ((heightVal / 100) * (heightVal / 100))).toFixed(
        3
      );
      BMI = parseFloat(BMI).toString();
      //Male &&  Female
      if (BMI < 18.5) {
        setResult(`${BMI} کمبود وزن`);
      } else if (BMI > 18.5 && BMI < 24.9) {
        setResult(`${BMI} نرمال`);
      } else if (BMI > 25 && BMI < 29.9) {
        setResult(`${BMI} اضافه وزن`);
      } else if (BMI > 30 && BMI < 34.9) {
        setResult(`${BMI} چاق`);
      } else if (BMI > 35) {
        setResult(`${BMI} خیلی چاق`);
      } else {
        setResult("");
      }
    } else {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }
  };
  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn path="/calculator" />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="pageTitle horizontalBorder">شاخص توده بدنی</div>
          <div className="scroll responsiveWidth calculatorPadding">
            <MaleOrFemale
              sex={sex}
              onTransGender={(gender) => changeGender(gender)}
            />
            {bmiData.map((data) => (
              <CalculatorInput
                key={data.id}
                {...data}
                value={data.name === "قد" ? heightVal : weightVal}
                showTooltip={
                  data.name === "قد" ? showHeightTooltip : showWeightTooltip
                }
                onChangeVal={(val) =>
                  handleInputChange(
                    val,
                    data.name === "قد" ? "height" : "weight"
                  )
                }
                onHide={() =>
                  handleTouchEnd(data.name === "قد" ? "height" : "weight")
                }
              />
            ))}
            <CalculatorResult
              title="شاخص توده بدنی"
              onCompute={handleComputing}
              result={result}
            />
          </div>
          <Alert
            showAlert={showAlert}
            alertText="قد کمتر از یک متر مجاز نیست"
            bottom="5rem"
          />
        </div>
      </div>
    </div>
  );
}
